module.exports = __webpack_public_path__ + "fonts/NotoSansKR-L.03d91ea.woff";